import React, { FC } from 'react';
import Routes from 'Routes';
import { shallowEqual, useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';
import XtraBreadcrumbs from 'components/XtraBreadcrumbs';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { selectBoothById } from 'models/cms/booths';
import { useTranslation } from 'react-i18next';
import CustomHelmet from 'components/CustomHelmet';
import { selectLocalizedEventName } from 'models/virtual_event';

interface BoothProfileHeaderProps {
  boothId: string;
}

const BoothProfileHeader: FC<BoothProfileHeaderProps> = ({ boothId }) => {
  const { lobby, hall } = useSelector((state) => state.eventConfigs.pageNames, shallowEqual);
  const { t } = useTranslation();
  const eventName = useSelector(selectLocalizedEventName, shallowEqual);
  const locale = useSelector(selectLocale, shallowEqual);
  const booth = useSelector((state) => selectBoothById(state, boothId), shallowEqual);
  const lobbyName = findAvailableLocale(lobby, locale) || t('page.lobby', 'Lobby');
  const hallName = findAvailableLocale(hall, locale) || t('page.hall', 'Exhibition Hall');
  const boothName = findAvailableLocale(booth?.name || {}, locale);

  return (
    <>
      <CustomHelmet>
        <meta charSet="utf-8" />
        <title>{`${boothName} | ${eventName}`}</title>
        <meta name="description" content={`${boothName} of ${eventName}.`} />
      </CustomHelmet>
      <XtraBreadcrumbs
        paths={[
          { name: lobbyName, to: Routes.lobby },
          { name: hallName, to: Routes.hall },
          { name: boothName },
        ]}
      />
    </>
  );
};

export default BoothProfileHeader;
